module.exports = __webpack_public_path__ + "static/media/selected_boatyard_marker.44fc390d.svg";